import { useQuery } from '@zg-rentals/react-query5';
import { useDispatch } from 'react-redux';
import { getSharedApplication } from '../api-ts';

export function useGetSharedApplication(shareId: string) {
  const dispatch = useDispatch();
  return useQuery({
    queryKey: ['getSharedApplication', shareId],
    queryFn: () => dispatch(getSharedApplication(shareId)),
  });
}
